import { RefillableDocumentDto } from './refillable-document.dto';

export class RefillableDocumentListResponse {
    refillableDocument: RefillableDocumentDto[];
    constructor(refillableDocument: RefillableDocumentDto[]) {
        this.refillableDocument = refillableDocument;
    }
}
